import Image from 'next/image';
import type React from 'react';

import CategorySpecificPoster from '@/app/[locale]/(default-layout)/program/_components/CategorySpecificPoster';

import { HrefOrHrefWithParams } from 'next-intl/dist/types/navigation/shared/utils';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

import { CachedContentData } from '@/hooks/useCachedContentData';

import ImageWithTransition from '@cineamo/ui/src/image/ImageWithTransition';

import { Link } from '@/i18n/routing';

const gretaRibbonImage = loadAsset('/images/im-gretaRibbon-trimmed.png');

const ShowingListItemImage: React.FC<{
    content: CachedContentData;
    href?: HrefOrHrefWithParams<'/program/[contentId]'>;
}> = ({ content, href }) => {
    const WrapperElement = href ? Link : 'div';

    return (
        <WrapperElement
            href={href ?? ''}
            aria-label={content.title}
            className="relative w-full h-210 lg:h-240 rounded-8 overflow-clip">
            {content.backdropImage ? (
                <div className="w-full h-full">
                    <ImageWithTransition
                        className="w-full h-full object-cover"
                        src={content.backdropImage}
                        blurDataURL={content.backdropBlurDataImage}
                        width={600}
                        height={400}
                        alt=""
                    />
                    {content.posterImage && (
                        <div
                            className="absolute w-full h-full top-0 left-0 p-16 lg:p-18 flex flex-row items-center"
                            style={{
                                background: 'linear-gradient(to right, rgba(0, 0, 0, 0.7) 0 25%, rgba(0, 0, 0, 0) 50%)'
                            }}>
                            <ImageWithTransition
                                className="w-auto h-full aspect-[2/3] rounded-4 object-cover"
                                src={content.posterImage}
                                blurDataURL={content.posterBlurDataImage}
                                width={200}
                                height={300}
                                alt=""
                            />
                        </div>
                    )}
                </div>
            ) : (
                <CategorySpecificPoster
                    category={content.eventRequestCategory ?? ''}
                    type="backdrop"
                />
            )}
            {content.movieAccessibility && (
                <Image
                    className="absolute pointer-events-none aspect-square w-[58px] bottom-0 right-0"
                    src={gretaRibbonImage}
                    alt="GRETA"
                    width={930}
                    height={930}
                />
            )}
        </WrapperElement>
    );
};

export default ShowingListItemImage;
